export default {
  sections: {
    order_summary: 'Total do pedido',
  },
  labels: {
    add_items: 'Adicione artigos para começar',
    item_count_one: '{{count}} artigo',
    item_count_other: '{{count}} artigos',
  },
  buttons: {
    return: 'Voltar para revisão do pedido',
  },
};
